module.exports = {"511071006":"壕子口街道","511071101":"交通镇","511071102":"四合镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511071.json
// module id = 2327
// module chunks = 0